import { CmsLayerTree } from "./CmsLayerTree";

export class CmsLeftNavigator {
    readonly #layers: CmsLayerTree;

    constructor(private readonly root: HTMLElement) {
        this.#layers = new CmsLayerTree(root);
    }

    init(): void {
        this.#layers.init();
        this.root.querySelectorAll<HTMLButtonElement>("[data-cms-left-tab]").forEach((button) => {
            button.addEventListener("click", () => this.#activate(button.dataset.cmsLeftTab ?? "pages"));
        });
        this.root.addEventListener("click", (event) => {
            const trigger = (event.target as HTMLElement | null)?.closest<HTMLElement>("[data-cms-tree-search-focus]");
            if (!trigger || !this.root.contains(trigger)) return;
            event.preventDefault();
            const input = this.root.querySelector<HTMLInputElement>("[data-cms-tree-search]");
            input?.focus({ preventScroll: true });
            input?.select();
        });
        this.root.addEventListener("input", (event) => {
            const input = (event.target as HTMLElement | null)?.closest<HTMLInputElement>("[data-cms-tree-search]");
            if (!input || !this.root.contains(input)) return;
            this.#filterTree(input.value);
        });
    }

    refreshLayers(): void {
        this.#layers.refresh();
    }

    #activate(tab: string): void {
        this.root.querySelectorAll<HTMLButtonElement>("[data-cms-left-tab]").forEach((button) => {
            const active = button.dataset.cmsLeftTab === tab;
            button.classList.toggle("is-active", active);
            button.setAttribute("aria-selected", String(active));
        });
        this.root.querySelectorAll<HTMLElement>("[data-cms-left-panel]").forEach((panel) => {
            panel.hidden = panel.dataset.cmsLeftPanel !== tab;
        });
        if (tab === "layers") this.refreshLayers();
    }

    #filterTree(value: string): void {
        const query = value.trim().toLowerCase();
        const items = Array.from(this.root.querySelectorAll<HTMLElement>("[data-cms-tree-item]"));
        items.forEach((item) => {
            if (query === "") {
                item.hidden = false;
                return;
            }
            const selfText = item.dataset.search ?? "";
            const childMatches = Array.from(item.querySelectorAll<HTMLElement>("[data-cms-tree-item]"))
                .some((child) => (child.dataset.search ?? "").includes(query));
            item.hidden = !selfText.includes(query) && !childMatches;
        });
    }
}
